{
    "Policies_List.search.search": "Search",
    "Policies_List.search.fname": "First Name",
    "Policies_List.search.lname": "Last Name",
    "Policies_List.search.allBrokerages": "All Brokerages",
    "Policies_List.search.allBrokers": "All Brokers",
    "Policies_List.search.allProducts": "All Products",
    "Policies_List.search.insuredPhone": "Insured Phone",
    "Policies_List.search.insuredEmail": "Insured Email",
    "Policies_List.search.referenceNumber": "Reference Number",
    "Policies_List.search.policyNumber": "Policy Number",
    "Policies_List.search.quoteNumber": "Quote Number",
    "Policies_List.search.tag": "Tag",
    "Policies_List.search.doingBusinessAs": "Doing Business as",
    "Policies_List.search.clear": "Clear",
    "Policies_List.search.status.all": "All Transaction Status",
    "Policies_List.search.status.abandoned": "Abandoned",
    "Policies_List.search.status.accepted": "Accepted",
    "Policies_List.search.status.bindRequested": "Bind Requested",
    "Policies_List.search.status.bound": "Bound",
    "Policies_List.search.status.cancelled": "Cancelled",
    "Policies_List.search.status.incomplete": "Incomplete",
    "Policies_List.search.status.issued": "Issued",
    "Policies_List.search.status.lost": "Lost",
    "Policies_List.search.status.quoted": "Quoted",
    "Policies_List.search.status.quoteAccepted": "Quote Accepted",
    "Policies_List.search.status.quoteIssued": "Quote Issued",
    "Policies_List.search.status.referred": "Referred",
    "Policies_List.search.status.rejected": "Rejected",
    "Policies_List.search.status.submitted": "Submitted",
    "Policies_List.search.transactionType.all": "All Transaction Types",
    "Policies_List.search.transactionType.renewal": "Renewal",
    "Policies_List.search.transactionType.newBusiness": "New Business",
    "Policies_List.search.transactionType.endorsement": "Endorsement",
    "Policies_List.search.transactionType.cancellation": "Cancellation",
    "Policies_List.search.transactionType.certificate": "Certificate",
    "Policies_List.table.referenceNumber": "Reference #",
    "Policies_List.table.policyNumber": "Policy #",
    "Policies_List.table.name": "Name",
    "Policies_List.table.doingBusinessAs": "Doing Business As",
    "Policies_List.table.product": "Product",
    "Policies_List.table.creationDate": "Creation Date",
    "Policies_List.table.brokerage": "Brokerage",
    "Policies_List.table.assignedTo": "Assigned To",
    "Policies_List.table.type": "Type",
    "Policies_List.table.status": "Status",
    "Policies_List.table.insuredName": "Insured Name",
    "Policies_List.table.quoteNumber": "Quote #",
    "Policies_List.table.quoteTags": "Tags",
    "Policies_List.scroll.start": "Scroll to start",
    "Policies_List.scroll.end": "Scroll to end"
}
